import { render } from "./archiveDocuments.vue?vue&type=template&id=1d9034a4&scoped=true&ts=true"
import script from "./archiveDocuments.vue?vue&type=script&lang=ts"
export * from "./archiveDocuments.vue?vue&type=script&lang=ts"

import "./archiveDocuments.vue?vue&type=style&index=0&id=1d9034a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9034a4"]])

export default __exports__